<template>
  <div>
    <h3 class="mb-4 text-lg font-semibold m-7">Apheresis Donation Information</h3>
    <form class="ml-6 mr-6" @submit.prevent="moveToNext">
      <EducationalAlerts
        title="WHAT IS APHERESIS DONATION?"
        message="Apheresis is a specialized blood donation procedure in which a machine collects a specific blood component, such as platelets, while returning the remaining blood components back to your body"
        type="warning"
        :hasMargin="true"
      />
      <EducationalAlerts
        title="WHAT HAPPENS DURING DONATION?"
        message="
              <li>Registration and donor screening</li>
              <li>Health assessment and platelet count check</li>
              <li>Connection to an apheresis machine</li>
              <li>Collection of platelets while other blood components are returned to you</li>
              <li>Post-donation observation</li>
             "
        type="warning"
      />
      <EducationalAlerts
        title="HOW LONG DOES IT TAKE?"
        message="
              <li>Screening: 2 hours</li>
              <li>Donation procedure: 60&ndash;90 minutes</li>
             "
        type="warning"
      />
      <EducationalAlerts
        title="Eligibility Requirements"
        message="You may be eligible if you:
        <li>Have big hand veins</li>
        <li>Meet the required age and weight, height criteria</li>
        <li>Have an adequate platelet count (250 - 450)</li>
        <li>Pass the Questionnaire Assessment</li>
        Additional criteria may apply according to hospital or national guidelines."
        type="warning"
      />

      <div class="flex justify-between mt-4">
        <button type="button" class="px-4 py-2 text-orange-500 border border-orange-500 rounded" @click="moveToPrevious">Back</button>
        <CustomButton type="submit" label="Next" class="px-4 py-2" bg-class="bg-custom-yellow" />
      </div>
    </form>
  </div>
</template>

<script>
import EducationalAlerts from '@/components/EducationalAlerts.vue';
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: "NewDonorEducationalPamphlet",
  components: {
    EducationalAlerts,
    CustomButton,
  },
  methods: {
    moveToNext() {
      this.$emit('move-to-next-step');
    },
    moveToPrevious() {
      this.$emit('move-to-previous-step');
    }
  },
};
</script>